<script>
	import { onMount } from 'svelte';
	import { getText, jumpByAnchor } from '../../../../share/utils';

	let div_tom;

	onMount(() => {
		jumpByAnchor(div_tom);
	});
</script>

<div bind:this={div_tom} id="tom" class="page-special-tom marginbox">
	<div class="flex structure">
		<div class="flex element">
			<div>
				<img loading="lazy" alt="TomApp - Login" src="./../img/16.Individuelle_Klasse/04.tom/TOMapp-iPhone-Login.webp">
				<img loading="lazy" alt="TomApp - Liste" src="./../img/16.Individuelle_Klasse/04.tom/TOMapp-iPhone-Liste2.webp">
				<img loading="lazy" alt="TomApp - Details" src="./../img/16.Individuelle_Klasse/04.tom/TOMapp-iPhone-Details2.webp">
			</div>
		</div>
		
		<div class="flex row structure-1">
			<div class="flex element">
				<img loading="lazy" alt="TomApp - Desktop - Design" src="./../img/16.Individuelle_Klasse/04.tom/TOMapp-Tablet-2.webp">
			</div>
			<div class="flex col element text">
				<h2>{getText("16.04.01_h2")}</h2>
				<p class="caption">{getText("16.04.02_caption")}</p>
				<p class="caption blue">Project Lead: <a href="//www.eckpunkt.com" target="_blank">www.eckpunkt.com</a></p>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}
	
	.page-special-tom {
		margin-top: $spacing-mobile;
		
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;

			div {
				display: grid;
				grid-template-columns: 1fr 1fr 1fr;
				justify-content: space-between;
				width: 100%;
				gap: $media-gap;
			}
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
			margin: 0 0 $spacing-mobile 0;
			
			.element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
			
			> .element:last-of-type {
				margin-bottom: 0;
			}
		}
		
		.structure-1 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element:first-of-type,
			> .element:nth-of-type(2) {
				@include for-tablet-portrait-up {
					width: 50%;
				}
			}
			
			> .element:nth-of-type(2) {
				@include for-tablet-portrait-up {
					padding-left: $media-gap;
				}
			}
		}
		
		.text {
			margin: 0;
		}
	}
</style>
